export type PulseEventCategory = "Bars" | "Clubs" | "Rooftop" | "Concerts";

const CATEGORY_MAP: Record<string, PulseEventCategory> = {
  bars: "Bars",
  bar: "Bars",
  clubs: "Clubs",
  club: "Clubs",
  concerts: "Concerts",
  concert: "Concerts",
  rooftop: "Rooftop",
  rooftops: "Rooftop",
};

const KNOWN = new Set<string>(["Bars", "Clubs", "Rooftop", "Concerts"]);

function normalizeCategory(raw: string | null | undefined): PulseEventCategory {
  if (!raw) return "Bars";
  const key = raw.trim().toLowerCase();
  if (CATEGORY_MAP[key]) return CATEGORY_MAP[key];
  if (KNOWN.has(raw.trim())) return raw.trim() as PulseEventCategory;
  return "Bars";
}

/** Event-level category when set; otherwise inherit venue category (legacy). */
export function resolvePulseEventCategory(
  eventCategory: string | null | undefined,
  venueCategory: string | null | undefined,
): PulseEventCategory {
  if (eventCategory != null && String(eventCategory).trim() !== "") {
    return normalizeCategory(eventCategory);
  }
  return normalizeCategory(venueCategory);
}
